export default __webpack_public_path__ + "assets/images/7544ad8c78dbb87f12fb49bd462109cd.png";